module.exports = "/images/london-18.jpg";